module.exports = __webpack_public_path__ + "img/Gear.ff2c4ba5.svg";